import React from 'react';
import {OSDInstance} from '../OSDInstance'
import {LineText} from './LineText'

import "./image-text-wrapper.css"
import { number } from 'prop-types';

export interface MyComponentProps {
  imageurl: string, //@description imageurl (without iiif parameters) for which logo will be requested
  coords?: string, //@description default setting for viewer width; default is 1000
  lineTextViewStyle?: string, //@description a prop to control styling of line text display; "thin" (default) which has no padding and is left aligned or "wide" which has padding and is justified
  viewerWidth?: number,
  text?: string, 
  label?: string,
  number?: string,
}


export const ImageTextWrapper: React.FC<MyComponentProps> = (props) => {
  const viewerWidth = props.viewerWidth || 1000;
  return(
   
      // <div className={props.targetLabel === props.label ? "image-text-wrapper target" : "image-text-wrapper"}>
      <div style={{width: props.viewerWidth + "px"}}>
        {/* <div className="labelImageWrapper"> */}
        <OSDInstance
          imageurl={props.imageurl}
          
          coords={props.coords}
          viewerWidth={viewerWidth}
          //lineFocusCoords={this.props.lineFocusCoords}
          />
        {/* </div> */}
        {(props.text || props.number || props.label) && <LineText text={props.text} number={props.number} label={props.label} lineTextViewStyle={props.lineTextViewStyle}/>}
      </div>
    );
  }
  